import Avatar1 from '../static/images/utils/avatars/Stock 1.svg'
import Avatar2 from '../static/images/utils/avatars/Stock 5.svg'
import Avatar3 from '../static/images/utils/avatars/Stock 3.svg'
import Avatar4 from '../static/images/utils/avatars/Stock 4.svg'

export const employeesTest = [
  {
    "id": 1,
    "employer_id": 1,
    "identification_type_id": 1,
    "identification_number": "1001191203",
    "first_name": "Clara",
    "middle_name": "Ines",
    "last_name": "CASTILLO ",
    "surname": "OLAVE",
    "email": "claracastillo176@gmail.com",
    "address": "Calle 70 No. 70-35 Piso 2",
    "phone": "3043872",
    "mobile": "3212953088",
    "gender_id": 1,
    "birthdate": "1989-09-09T00:00:00Z",
    "birthplace_country_id": 1,
    "marital_status_id": 1,
    "picture": Avatar1,
    "password": " ",
    "created_at": "2019-11-02T14:39:19.485059Z",
    "updated_at": "0001-01-01T00:00:00Z"
  },
  {
    "id": 2,
    "employer_id": 2,
    "identification_type_id": 1,
    "identification_number": "1001191533",
    "first_name": "Juan",
    "middle_name": "Alexis",
    "last_name": "Mora",
    "surname": "Angulo",
    "email": "claracastillo176@gmail.com",
    "address": "Calle 70 No. 70-35 Piso 2",
    "phone": "3043872",
    "mobile": "3212953088",
    "gender_id": 1,
    "birthdate": "1989-09-09T00:00:00Z",
    "birthplace_country_id": 1,
    "marital_status_id": 1,
    "picture": Avatar2,
    "password": " ",
    "created_at": "2019-11-02T14:39:19.485059Z",
    "updated_at": "0001-01-01T00:00:00Z"
  },
  {
    "id": 3,
    "employer_id": 2,
    "identification_type_id": 1,
    "identification_number": "1023191533",
    "first_name": "Evelyn",
    "middle_name": "",
    "last_name": "Castrejón",
    "surname": "Jiménez",
    "email": "claracastillo176@gmail.com",
    "address": "Calle 70 No. 70-35 Piso 2",
    "phone": "3043872",
    "mobile": "3212953088",
    "gender_id": 1,
    "birthdate": "1989-09-09T00:00:00Z",
    "birthplace_country_id": 1,
    "marital_status_id": 1,
    "picture": Avatar3,
    "password": " ",
    "created_at": "2019-11-02T14:39:19.485059Z",
    "updated_at": "0001-01-01T00:00:00Z"
  },
  {
    "id": 4,
    "employer_id": 2,
    "identification_type_id": 1,
    "identification_number": "1023194333",
    "first_name": "Karen",
    "middle_name": "Atenea",
    "last_name": "Becerra",
    "surname": "",
    "email": "claracastillo176@gmail.com",
    "address": "Calle 70 No. 70-35 Piso 2",
    "phone": "3043872",
    "mobile": "3212953088",
    "gender_id": 1,
    "birthdate": "1989-09-09T00:00:00Z",
    "birthplace_country_id": 1,
    "marital_status_id": 1,
    "picture": Avatar4,
    "password": " ",
    "created_at": "2019-11-02T14:39:19.485059Z",
    "updated_at": "0001-01-01T00:00:00Z"
  }
]
